import { Headline3 } from 'aimo-ui';
import BulletList from 'components/common/BulletList';
import TextWithLinks, { TextLink } from 'components/common/TextWithLinks';
import useOrganizationName, {
  useOrganizationWebsite,
} from 'hooks/useOrganizationName';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Linking } from 'react-native';
import { useUiStore } from 'stores/uiStore';
import { StyledWrapper, WhiteBox } from 'styles/ContainerStyles';

const PREFIX = 'vehicle.cameraRecognition.tutorial';

const SECTIONS = [
  {
    key: 'responsibilities',
    steps: ['authorisedUser', 'deactivateWhenNotUser', 'legiblePlate'],
  },
  { key: 'billing', steps: ['automaticCharge', 'failedPayment'] },
  {
    key: 'service',
    steps: ['notifications', 'targetsMayChange', 'markedLocations'],
  },
];

const LEGAL_STEPS = ['terms', 'dataProcessing', 'moreInfo'];

const CameraRecognitionTutorial = () => {
  const { t } = useTranslation();
  const organizationName = useOrganizationName();
  const website = useOrganizationWebsite();

  const legalLinks: Record<string, TextLink> = {
    termsAndConditions: {
      onPress: () => useUiStore.getState().setSheetModal('termsAndConditions'),
    },
    privacyPolicy: {
      onPress: () => useUiStore.getState().setSheetModal('privacyPolicy'),
    },
    website: { onPress: () => Linking.openURL(website.url) },
  };

  return (
    <>
      <StyledWrapper>
        <Headline3>{t(`${PREFIX}.newTitle`)}</Headline3>
      </StyledWrapper>
      {SECTIONS.map(({ key, steps }) => (
        <WhiteBox key={key}>
          <StyledWrapper mb={10}>
            <Headline3>{t(`${PREFIX}.${key}.title`)}</Headline3>
          </StyledWrapper>
          <BulletList
            items={steps.map((step) => ({
              key: step,
              text: t(`${PREFIX}.${key}.${step}`, { organizationName }),
            }))}
          />
        </WhiteBox>
      ))}
      <WhiteBox>
        <StyledWrapper mb={10}>
          <Headline3>{t(`${PREFIX}.legal.title`)}</Headline3>
        </StyledWrapper>
        <BulletList
          items={LEGAL_STEPS.map((step) => ({
            key: step,
            text: (
              <TextWithLinks
                i18nKey={`${PREFIX}.legal.${step}`}
                values={{ organizationName, website: website.label }}
                links={legalLinks}
              />
            ),
          }))}
        />
      </WhiteBox>
    </>
  );
};

export default CameraRecognitionTutorial;
